/* Takes in a function to callback and a time value. The timeout value is set on the first call  
   and if its then called again while the timeout is set then the timeout is cleared and reset. 
   This delays the return till after the specified time is passed.*/

export  const _debounce = <F extends (...args: any[]) => any>(func: F, waitFor: number) => {
	let timeout

	return (...args: Parameters<F>): Promise<ReturnType<F>> =>
		new Promise(resolve => {
			if (timeout) {
				clearTimeout(timeout)
			}

			timeout = setTimeout(() => resolve(func(...args)), waitFor)
		})
}